// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill2","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M5.79297 12.75L7.35547 11H4.23047L5.79297 12.75Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"menu-unfold"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M5.79297 12.75L7.35547 11H4.23047L5.79297 12.75Z","mask":"props.overlapMaskUrl_fill2"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 19L3 19M21 5H3M21 12L12 12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M5.79297 12.75L7.35547 11H4.23047L5.79297 12.75Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MenuUnfoldIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'menu-unfold',
    ref,
    icon: element,
  },
));

MenuUnfoldIcon.displayName = 'MenuUnfoldIcon';

export default MenuUnfoldIcon;
